import React, { ChangeEventHandler, useEffect, useMemo, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import Option from "../components/Option";
import { SalesPerformanceList, SalesPerformanceType } from "../components/commonWidget";
import chartIcon from "../components/custom/assets/images/dashboard/chart_icon.svg";
import { FormInput } from "../components/custom/components";
import FormInput2 from "../components/custom/components/FormInput2";
import SalesPerformanceTable from "../components/custom/components/SalesPerformanceTable";
import BarChart from "../components/custom/components/charts/apex/BarChart";
import LineChart from "../components/custom/components/charts/apex/LineChart";
import { COLORS } from "../components/custom/constants";
import UserLayout from "../components/custom/layouts/UserLayout";
import { ToastTypes, useToast } from "../components/toast/ToastProvider";
import { defaultbrand, defaultLocation, defaultPortfolio, defaultTradeCategory, defaultTradeSubCategory, DropDownOption1, PAGE_SIZE } from "../config";
import api, { APIResponse, getAxiosRequestConfig } from "../config/api";
import { YearOptions } from "../config/functions";
import { AuthUserType } from "../redux/actions/authUserActions";
import { BrandType } from "../redux/actions/brandActions";
import { BrandCompanyType } from "../redux/actions/brandCompanyActions";
import { PortfolioType } from "../redux/actions/portfolioActions";
import {
  OptionsTypes,
  addToSelectedOption,
} from "../redux/actions/selectedOptionsActions";
import { SiteType } from "../redux/actions/siteActions";
import { TradeCategoryType } from "../redux/actions/tradeCategoryActions";
import { TradeSubCategoryType } from "../redux/actions/tradeSubCategoryActions";
import { StoreState } from "../redux/store";
import { CatSubCatCompanyWithBrandRelationDataType } from "./TransactionBillWiseReport";
import Loader from "../components/custom/components/Loader";
// import Modal from "../components/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowMaximize } from "@fortawesome/free-solid-svg-icons";
import { areaType } from "../redux/actions/areaActions";
import { outletType } from "../redux/actions/outletActions";
import { useLocation } from "react-router-dom";
import { UserLog } from "../config/common";
import { FootfallvsSalesYearly,FootfallvsSalesMonthly,FootfallvsSalesWeekly } from "../components/footfallReports/footfallvssales";
import Modal from "../components/Modal";
import SingleSelect from "../components/custom/components/SingleSelect";
import SingleSelect1 from "../components/custom/components/SingleSelect1";

export interface DropDownOption {
  value: number;
  label: string;
  imgUrl: string;
}
interface RecordsForMonth {
  center: number;
  transyear: number;
  transmonth: number;
  sales: string;
  nooftransactions: number;
  footfall: number;
  averageticketsize: number;
  conversionrate: number;
}
interface RecordsForYear {
  center: number;
  sales: string;
  transyear: number;
  nooftransactions: number;
  footfall: number;
  averageticketsize: number;
  conversionrate: number;
}

interface RecordsForWeek {
  center: number;
  transyear: number;
  transweek: number;
  sales: string;
  nooftransactions: number;
  footfall: number;
  averageticketsize: number;
  conversionrate: number;
}

interface YearlyFootfallVsSalesReportType {
  portfolio: number;
  record: RecordsForYear[];
  count?: number;
}

interface MonthlyFootfallVsSalesReportType {
  portfolio: number;
  record: RecordsForMonth[];
  count?: number;
}

interface WeeklyFootfallVsSalesReportType {
  portfolio: number;
  record: RecordsForWeek[];
  count?: number;
}

const FootfallVsSalesReport: React.FC = () => {
  const toast = useToast();
  const dispatch = useDispatch();
  const pageName = useLocation()
  const authUser = useSelector<StoreState, AuthUserType | null>(
    (state) => state?.authUser
  );
  const authUserToken = useSelector<StoreState, AuthUserType | null>(
    (state) => state?.authUser
  )?.["auth-token"]!;
  const config = getAxiosRequestConfig(authUserToken);

  const authUserSiteId = authUser?.siteId;

  const portfolioOption = useSelector<StoreState, PortfolioType[]>(
    (state) => state?.portfolio
  );
  const siteOption = useSelector<StoreState, SiteType[]>((state) => state?.site);
  const brandOption = useSelector<StoreState, BrandType[]>(
    (state) => state?.brand
  );
  const brandCompanyOption = useSelector<StoreState, BrandCompanyType[]>(
    (state) => state?.brandCompany
  );
  const selectedOption = useSelector<StoreState, OptionsTypes>(
    (state) => state?.selectedOption
  );
  const outletList = useSelector<StoreState, outletType[]>(
    (state) => state?.outlet
  );  
  const localityOption = useSelector<StoreState, areaType[]>(
    (state) => state?.locality
  );

  const weekArray = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "50",
    "51",
    "52",
    "53",
  ];

  const filteredBrandCompany = brandCompanyOption?.filter(
    (a) => a?.retailid !== null
  );

  const filteredBrand = brandOption?.filter((a) => {
    return brandCompanyOption?.some(
      (b) =>
        b?.id?.toString() === a?.companyid?.toString() && b?.retailid !== null
    );
  });

  const port =
    authUser?.portfolioId !== undefined && authUser?.portfolioId !== null
      ? authUser?.portfolioId?.split(",")
      : [];

  let portfolioData = port
    ?.map((pe) => {
      return portfolioOption?.filter(
        (f) => f?.id?.toString() === pe?.toString()
      );
    })
    ?.flat(1);

  const pname = portfolioData[0]?.name;

  const st =
    authUser?.siteId !== undefined && authUser?.siteId !== null
      ? authUser?.siteId?.split(",")
      : [];

  let siteData = st
    ?.map((pe) => {
      return siteOption?.filter((f) => f?.id?.toString() === pe?.toString());
    })
    ?.flat(1);

  const br =
    authUser?.brandId !== undefined && authUser?.brandId !== null
      ? authUser?.brandId?.split(",")
      : [];

  let brandData = br
    ?.map((b) => {
      return filteredBrand?.filter((f) => f?.id?.toString() === b?.toString());
    })
    ?.flat(1);

  const categoryOption = useSelector<StoreState, TradeCategoryType[]>(
    (state) => state?.tradeCategory
  );
  const subCategoryOption = useSelector<StoreState, TradeSubCategoryType[]>(
    (state) => state?.tradeSubCategory
  );

  const [
    catSubCatCompanyWithBrandRelationData,
    setCatSubCatCompanyWithBrandRelationData,
  ] = useState<CatSubCatCompanyWithBrandRelationDataType[]>([]);

  const month = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  const [year, setYear] = useState<Date>(new Date());
  const [week, setWeek] = useState<string>("");
  const [yearAndMonth, setYearAndMonth] = useState<Date>(new Date());

  const [valueIn, setValueIn] = useState<string>("");

  const [portfolios, setPortfolios] = useState<string>("");
  const [sites, setSites] = useState<string>("");
  const [brands, setBrands] = useState<string>("");

  const [location, setLocation] = useState<string>("");
  const [categories, setCategories] = useState<string>("");
  const [subCategories, setSubCategories] = useState<string>("");

  const [loader, setLoader] = useState<boolean>(false);

  const [selection, setSelection] = useState<SalesPerformanceType>(
    SalesPerformanceList?.MONTHLY
  );

  const [yearlyData, setYearlyData] = useState<
    YearlyFootfallVsSalesReportType[]
  >([]);
  const [monthlyData, setMonthlyData] = useState<
    MonthlyFootfallVsSalesReportType[]
  >([]);
  const [weeklyData, setWeeklyData] = useState<
    WeeklyFootfallVsSalesReportType[]
  >([]);

  const limit = PAGE_SIZE;
  const [offset, setOffset] = useState<number>(0);
  const [range, setRange] = useState<number[]>([]);
  const [length, setLength] = useState<number>(50);
  const [yearDropDown, setYearDropDown] = useState<number[]>(YearOptions());
  const [condition,setCondition] = useState<boolean>(false)

  const [showModal, setShowModal] = useState<boolean>(false);
  const [isButtonVisible, setButtonVisible] = useState(false);
  const [disableLocality, setDisableLocality] = useState<boolean>(false);

  const [portfolioDrop, setPortfolioDrop] = useState<DropDownOption[]>([]);
  const [locationDrop, setLocationDrop] = useState<DropDownOption[]>([]);
  const [catDrop,setCatDrop] = useState<DropDownOption[]>([])
  const [subcatDrop,setSubcatDrop] = useState<DropDownOption[]>([])
  const [brandDrop,setBrandDrop] = useState<DropDownOption[]>([])

  const showExpandModalHandler = () => {
    setShowModal(true)
  };
  
  const SiteFilteredByPortfolio = useMemo<SiteType[]>(() => {
    if (portfolios !== "") {
      return siteData?.filter((s) => {
        return s?.pfid?.toString() === portfolios?.toString();
      });
    } else return [];
  }, [portfolios, siteData]);

  const subCategoryFilteredByCategory = useMemo<TradeSubCategoryType[]>(() => {
    if (categories !== "") {
      return subCategoryOption?.filter((sc) => {
        return sc?.catid?.toString() === categories?.toString();
      });
    } else return [];
  }, [categories, subCategoryOption]);

  const BrandFilteredByCompany = useMemo<BrandType[]>(() => {
    if (subCategories !== "") {
      let brands: BrandType[] = [];
      catSubCatCompanyWithBrandRelationData?.forEach((s) => {
        let obj = s?.record?.find((r) =>
          r?.tradesubcatids?.split(",")?.includes(subCategories)
        );
        obj?.brandids?.split(",")?.forEach((m) => {
          let bc = brandData?.find((f) => f?.id?.toString() === m);
          brands?.push(bc!);
        });
      });
      return brands;
    } else if (categories !== "") {
      let brands: BrandType[] = [];
      catSubCatCompanyWithBrandRelationData?.forEach((s) => {
        let obj = s?.record?.find((r) => r?.tradecatid?.toString() === categories);
        obj?.brandids?.split(",")?.forEach((m) => {
          let bc = brandData?.find((f) => f?.id?.toString() === m);
          brands?.push(bc!);
        });
      });
      return brands;
    } else return brandData;
  }, [
    brandData,
    catSubCatCompanyWithBrandRelationData,
    categories,
    subCategories,
  ]);
  const handleWeek: ChangeEventHandler<HTMLInputElement> = (e) => {
    setWeek(e?.target?.value);
  };
  const monthlyHandler = () => {
    setSelection(SalesPerformanceList?.MONTHLY);
  };
  const yearlyHandler = () => {
    setSelection(SalesPerformanceList?.YEARLY);
  };
  const weeklyHandler = () => {
    setSelection(SalesPerformanceList?.WEEKLY);
  };

  const handlePortfolioDrop = (selected: any) => {
    if(selected.length>0){
      const selectedPortfolio = selected as DropDownOption[];
      if(selectedPortfolio[0].value!==null&&selectedPortfolio[0].value!==0){
        setPortfolioDrop(selectedPortfolio)
        setPortfolios(selectedPortfolio[0]?.value?.toString())
        const data = { ...selectedOption, portfolio: selectedPortfolio[0]?.value?.toString() };
        dispatch(addToSelectedOption(data));
        setOffset(0);
      }
  }
  };
  
  const handleClearPortfolio = () =>{
    let pid =portfolioData[0] && portfolioData[0]?.id? portfolioData[0].id?.toString(): "";
    setPortfolios(selectedOption.portfolio ? selectedOption.portfolio : pid);
    const b = portfolioOption.filter((a)=>a?.id?.toString()===pid?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.name,
        imgUrl: b[0]?.logourl, 
      };
      setPortfolioDrop([val]);
      setLocation("");
      setLocationDrop([])
      const data = { ...selectedOption, portfolio: b[0]?.id?.toString(),location:''};
      dispatch(addToSelectedOption(data));
      setOffset(0);
  }
  }
  
  
  const handleLocationDrop = (selected: any) => {
    if(selected.length>0){
      const selectedLocation = selected as DropDownOption[];
      if(selectedLocation[0].value!==null&&selectedLocation[0].value!==0){
        setLocationDrop(selectedLocation)
        setLocation(selectedLocation[0]?.label?.toString())
       const data = { ...selectedOption,location: selectedLocation[0]?.label?.toString()};
       dispatch(addToSelectedOption(data));
       setOffset(0);
      }
    }
  };
  
  const handleClearLocation = () =>{
       setLocationDrop([])
       setLocation('')
       const data = { ...selectedOption,location: ""};
       dispatch(addToSelectedOption(data));
       setOffset(0);
  }
  
  const handleCatDrop = (selected: any) => {
    if(selected.length>0){
      const selectedCat = selected as DropDownOption[];
      if(selectedCat[0].value!==null&&selectedCat[0].value!==0){
        setCatDrop(selectedCat)
        setCategories(selectedCat[0]?.value?.toString())
        setSubcatDrop([])
        setSubCategories('')
        setBrandDrop([])
        setBrands('')
        const data = {
          ...selectedOption,
          category: selectedCat[0]?.value?.toString(),
          subCategory: "",
          brand: "",
        };
        dispatch(addToSelectedOption(data));
        setOffset(0);
      }
  }
  };
  
  const handleClearCat = () =>{
      setCatDrop([])
      setCategories('')
      setSubcatDrop([])
        setSubCategories('')
        setBrandDrop([])
        setBrands('')
       const data = { ...selectedOption,
        category: '',
        subCategory: "",
        brand: "",};
       dispatch(addToSelectedOption(data));
       setOffset(0); 
  }

  const handleSubcatDrop = (selected: any) => {
    if(selected.length>0){
      const selectedSubcat = selected as DropDownOption[];
      if(selectedSubcat[0].value!==null&&selectedSubcat[0].value!==0){
        setSubcatDrop(selectedSubcat)
        setSubCategories(selectedSubcat[0]?.value?.toString())
        setBrandDrop([])
        setBrands('')
        const data = { ...selectedOption,
          subCategory: selectedSubcat[0]?.value?.toString(),
          brand: "",};
         dispatch(addToSelectedOption(data));
         setOffset(0);
      }
  }
  };
  
  const handleClearSubcat = () =>{
      setSubcatDrop([])
        setSubCategories('')
        setBrandDrop([])
        setBrands('')
       const data = { ...selectedOption,
        subCategory: "",
        brand: "",};
       dispatch(addToSelectedOption(data));
       setOffset(0);
  }

  const handleBrandDrop = (selected: any) => {
    if(selected.length>0){
      const selectedBrand = selected as DropDownOption[];
      if(selectedBrand[0].value!==null&&selectedBrand[0].value!==0){
        setBrandDrop(selectedBrand)
        setBrands(selectedBrand[0]?.value?.toString())
       const data = { ...selectedOption,
        brand: selectedBrand[0]?.value?.toString()};
       dispatch(addToSelectedOption(data));
       setOffset(0);
      }
    }
  };
  
  const handleClearBrand = () =>{
        setBrandDrop([])
        setBrands('')
       const data = { ...selectedOption,
        brand: ""};
       dispatch(addToSelectedOption(data));
       setOffset(0);
  }
  

  const portFilter = portfolioOption?.filter((a)=>a?.id?.toString()===portfolios?.toString())
  const catFilter = categoryOption?.filter((a)=>a?.id?.toString()===categories?.toString())
  const subcatFilter = subCategoryOption?.filter((a)=>a?.id?.toString()===subCategories?.toString())
  const brandFilter = brandOption?.filter((a)=>a?.id?.toString()===brands?.toString())
  const localityFilter = localityOption?.filter((a)=>a?.area?.toString()===location?.toString())


  const combinedValues = [
    ...portFilter?.map(a => `Portfolio: ${a?.name}`),           
    ...catFilter?.map(c=> `Trade Category: ${c?.name}`),
    ...subcatFilter?.map(d=> `Trade Sub Category: ${d?.name}`),
    ...brandFilter?.map(f=> `Brand: ${f?.name}`),  
    ...localityFilter?.map(f=>`Locality: ${f?.area}`),     
    selection===SalesPerformanceList?.MONTHLY&&yearAndMonth!==null?`Year: ${yearAndMonth?.getFullYear()}, Month: ${yearAndMonth?.getMonth()+1}`:'',
    selection===SalesPerformanceList?.WEEKLY&&week!==""?`Week: ${week}, Year: ${year?.getFullYear()}`:'',
    selection===SalesPerformanceList?.YEARLY?`Period: ${year?.getFullYear()-2} - ${year?.getFullYear()}`:''
  ]
  ?.filter(name => name && name?.trim() !== '') 
  ?.join(', ');  


  const getSubtitle = useMemo<string>(() => {
    let subtxt = `\u3010Company\u3011: ${pname}`;
    if (location) {
      subtxt += `\u3010Locality\u3011: ${location}`;
    }
    if (categories?.length > 0 && categories !== undefined) {
      const categoryIndex = categoryOption?.findIndex(
          (a) => a?.id?.toString() === categories?.toString()
      );
      const categoryName = categoryOption[categoryIndex]?.name;
      subtxt += ` \n\u3010TradeCategory\u3011: ${categoryName}`;
    }
    if (subCategories?.length > 0) {
      const subcategoryIndex = subCategoryOption?.findIndex((a) =>
          a?.id?.toString() === subCategories?.toString()
      );
      const subcatName = subCategoryOption[subcategoryIndex]?.name;
      subtxt += ` \u3010TradeSubcategory\u3011: ${subcatName}`;
    }
    if (brands?.length > 0) {
      const brandIndex = filteredBrand?.findIndex(
          (a) => a?.id?.toString() === brands?.toString()
      );
      const brandname = filteredBrand[brandIndex]?.name;
      subtxt += ` \u3010Brand\u3011: ${brandname}`;
    }
    return subtxt;
  }, [pname, location, categories, subCategories, brands, categoryOption, subCategoryOption, filteredBrand]);


  const handleApply = () => {
    let error = false;
    if (portfolios === "") {
      toast("Select Portfolio", ToastTypes?.ERROR);
      error = true;
    }
    if (selection === SalesPerformanceList?.WEEKLY) {
      if (
        year === null ||
        (year !== null && year?.getFullYear()?.toString() === "")
      ) {
        toast("Select year", ToastTypes?.ERROR);
        error = true;
      }

      if (week === null || week === "") {
        toast("Select week", ToastTypes?.ERROR);
        error = true;
      }
    }
    if (selection === SalesPerformanceList?.MONTHLY) {
      if (
        yearAndMonth === null ||
        (yearAndMonth !== null &&
          yearAndMonth?.getFullYear()?.toString() === "" &&
          yearAndMonth?.getMonth()?.toString() === "")
      ) {
        toast("Select month and year", ToastTypes?.ERROR);
        error = true;
      }
    }

    const yr = yearAndMonth?.getFullYear();
    const mon = month[yearAndMonth?.getMonth()];

    var MgetData = {
      portfolio: portfolio,
      site: site,
      locality: location===defaultLocation?.label?'':location,
      tradeCategory: category,
      tradeSubCategory: subCategory,
      brand: brand,
      year: yr,
      month: mon,
      limit: limit?.toString(),
      offset: offset?.toString(),
      authUserRole: authUser?.roleId ? authUser?.roleId : "",
    };
    var WgetData = {
      portfolio: portfolio,
      site: site,
      locality: location===defaultLocation?.label?'':location,
      tradeCategory: category,
      tradeSubCategory: subCategory,
      brand: brand,
      year: year?.getFullYear(),
      weekNo: week,
      limit: limit?.toString(),
      offset: offset?.toString(),
      authUserRole: authUser?.roleId ? authUser?.roleId : "",
    };
    var YgetData = {
      portfolio: portfolio,
      site: site,
      locality: location===defaultLocation?.label?'':location,
      tradeCategory: category,
      tradeSubCategory: subCategory,
      brand: brand,
      limit: limit?.toString(),
      offset: offset?.toString(),
      authUserRole: authUser?.roleId ? authUser?.roleId : "",
    };

    if (
      error === false &&
      MgetData !== undefined &&
      YgetData?.limit !== "" &&
      YgetData?.offset !== ""
    ) {
      if (selection === SalesPerformanceList?.MONTHLY) {
        setLoader(true);
        api
          .post<APIResponse<{ records: MonthlyFootfallVsSalesReportType[] }>>(
            `kpi/sales/monthlySalesConversion`,
            MgetData,
            config
          )
          .then((response) => {
            if (response?.status === 200 && response?.data?.data) {
              const result = response?.data?.data?.records;
              setMonthlyData(result);
              setLoader(false);
              if(authUser){
                const logProps1 = {
                  action: 'Apply',
                  event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Apply Clicked (${selection}) | Data Status: ${result?.[0]?.count && result[0]?.count > 0 ? 'Success' : 'Empty'}`
                };
                UserLog(logProps1)
              }
              // calculateRange(limit)
            }
          })
          .catch((error) => {});
      } else if (selection === SalesPerformanceList?.YEARLY) {
        setLoader(true);
        api
          .post<APIResponse<{ records: YearlyFootfallVsSalesReportType[] }>>(
            `kpi/sales/yearlySalesConversion`,
            YgetData,
            config
          )
          .then((response) => {
            if (response?.status === 200 && response?.data?.data) {
              const result = response?.data?.data?.records;
              setYearlyData(result);
              setLoader(false);
              if(authUser){
                const logProps1 = {
                  action: 'Apply',
                  event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Apply Clicked (${selection}) | Data Status: ${result?.[0]?.count && result[0]?.count > 0 ? 'Success' : 'Empty'}`
                };
                UserLog(logProps1)
              }
              // calculateRange(limit)
            }
          })
          .catch((error) => {});
      } else if (selection === SalesPerformanceList?.WEEKLY) {
        setLoader(true);
        api
          .post<APIResponse<{ records: WeeklyFootfallVsSalesReportType[] }>>(
            `kpi/sales/weeklySalesConversion`,
            WgetData,
            config
          )
          .then((response) => {
            if (response?.status === 200 && response?.data?.data) {
              const result = response?.data?.data?.records;

              setWeeklyData(result);
              setLoader(false);
              if(authUser){
                const logProps1 = {
                  action: 'Apply',
                  event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Apply Clicked (${selection}) | Data Status: ${result?.[0]?.count && result[0]?.count > 0 ? 'Success' : 'Empty'}`
                };
                UserLog(logProps1)
              }
              // calculateRange(limit)
            }
          })
          .catch((error) => {});
      }
    } else {
      setMonthlyData([]);
      setYearlyData([]);
      setWeeklyData([]);
      setLoader(false);
    }
  };

  useEffect(() => {
    if (portfolios !== "") handleApply();
  }, [portfolios]);
  const getYearlyTableData = () => {
    var yearlyTableData: string[][] = [
      ["Center", "Year", "Total Sales", "Footfall"],
    ];

    const selectedYears = yearDropDown?.map((f) => f)?.sort();

    yearlyData?.forEach((y, i) => {

      siteOption
        ?.filter((ss) => ss?.pfid?.toString() === y?.portfolio?.toString())
        ?.filter((s2) => {
          if (sites) return s2?.id?.toString() === sites;
          else return s2;
        })
        ?.forEach((s) => {
          selectedYears?.forEach((yr) => {
            let sum = [];
            const row = y?.record
              ?.filter((r) => {

                return r?.transyear?.toString() === yr?.toString();
              })
              ?.filter((sw) => sw?.center?.toString() === s?.id?.toString());

            sum?.push(s?.name);
            sum?.push(yr?.toString());
            sum?.push(
              row[0]?.sales !== undefined && row[0]?.sales !== null
                ? row[0]?.sales
                : "-"
            );
            sum?.push(
              row[0]?.footfall !== undefined && row[0]?.footfall !== null
                ? row[0]?.footfall?.toString()
                : "-"
            );
            if (sum[2] !== "-" && sum[3] !== "-") yearlyTableData?.push(sum);
            else if (sum[3] !== "-" && sum[2] === "-")
              yearlyTableData?.push(sum);
            else yearlyTableData?.push();
          });
        });
    });
    return yearlyTableData;
  };

  const getMonthlyTableData = () => {
    var monthlyTableData: string[][] = [
      ["Center", "Year", "Month", "Total Sales", "Footfall"],
    ];

    const selectedYears = [
      yearAndMonth?.getFullYear(),
      yearAndMonth?.getFullYear() - 1,
    ];

    monthlyData?.forEach((y, i) => {
      siteOption
        ?.filter((ss) => ss?.pfid?.toString() === y?.portfolio?.toString())
        ?.filter((s2) => {
          if (sites) return s2?.id?.toString() === sites;
          else return s2;
        })
        ?.forEach((s) => {
          const rows = y?.record?.filter(
            (sw) => sw?.center?.toString() === s?.id?.toString()
          );
          rows?.forEach((row) => {
            let sum = [];

            sum?.push(s?.name);
            sum?.push(row?.transyear?.toString());
            sum?.push(row?.transmonth?.toString());
            sum?.push(
              row?.sales !== undefined && row?.sales !== null ? row?.sales : "-"
            );
            sum?.push(
              row?.footfall !== undefined && row?.footfall !== null
                ? row?.footfall?.toString()
                : "-"
            );
            if (sum[3] !== "-" && sum[4] !== "-") monthlyTableData?.push(sum);
            else if (sum[4] !== "-" && sum[3] === "-")
              monthlyTableData?.push(sum);
            else monthlyTableData?.push();
          });
        });
    });
    return monthlyTableData;
  };

  const getWeeklyTableData = () => {
    var weeklyTableData: string[][] = [
      ["Center", "Year", "Week", "Total Sales", "Footfall"],
    ];

    const selectedYears = [year?.getFullYear(), year?.getFullYear() - 1];

    weeklyData?.forEach((y, i) => {
      siteOption
        ?.filter((ss) => ss?.pfid?.toString() === y?.portfolio?.toString())
        ?.filter((s2) => {
          if (sites) return s2?.id?.toString() === sites;
          else return s2;
        })
        ?.forEach((s) => {
          const rows = y?.record?.filter(
            (sw) => sw?.center?.toString() === s?.id?.toString()
          );
          rows?.forEach((row) => {
            let sum = [];

            sum?.push(s?.name);
            sum?.push(row?.transyear?.toString());
            sum?.push(row?.transweek?.toString());
            sum?.push(
              row?.sales !== undefined && row?.sales !== null ? row?.sales : "-"
            );
            sum?.push(
              row?.footfall !== undefined && row?.footfall !== null
                ? row?.footfall?.toString()
                : "-"
            );
            if (sum[3] !== "-" && sum[4] !== "-") weeklyTableData?.push(sum);
            else if (sum[4] !== "-" && sum[3] === "-")
              weeklyTableData?.push(sum);
            else weeklyTableData?.push();
          });
        });
    });
    return weeklyTableData;
  };

  const portfolio = useMemo<number[]>(() => {
    return portfolios !== "" ? [parseInt(portfolios)] : [];
  }, [portfolios]);
  const site = useMemo<string[]>(() => {
    if (authUserSiteId) {
      return authUserSiteId?.split(",")?.map((s) => {
        return s?.toString();
      });
    } else {
      return [];
    }
  }, [authUserSiteId]);

  const brand = useMemo<number[]>(() => {
    if (brands !== "") {
      return brands !== "" ? [parseInt(brands)] : [];
    } else return br?.map((b) => parseInt(b));
  }, [brands]);

  const category = useMemo<number[]>(() => {
    return categories !== "" ? [parseInt(categories)] : [];
  }, [categories]);

  const subCategory = useMemo<number[]>(() => {
    return subCategories !== "" ? [parseInt(subCategories)] : [];
  }, [subCategories]);
  useEffect(()=>{    
    if(selectedOption?.isOutletUser){
      setDisableLocality(true);
    }
    else{
      setDisableLocality(false);
    }
  },[authUser, outletList,selectedOption]);

  useEffect(() => {
    setOffset(0);
  }, [yearAndMonth]);
  useEffect(() => {
    setOffset(0);
  }, [week, year]);


  useEffect(()=>{
    let pid =portfolioData[0] && portfolioData[0]?.id? portfolioData[0].id?.toString(): "";
    setPortfolios(selectedOption.portfolio ? selectedOption.portfolio : pid);
    const b = portfolioOption.filter((a)=>a?.id?.toString()===pid?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.name,
        imgUrl: b[0]?.logourl, 
      };
      setPortfolioDrop([val]);
    }
},[portfolioOption,selectedOption])

useEffect(()=>{
  setLocation(selectedOption.location? selectedOption.location:'')
  const b = localityOption.filter((a)=>a?.area?.toString()===selectedOption.location?.toString())
  if (b?.length > 0 && b[0]?.id !== undefined) {
    const val: DropDownOption = {
      value: b[0]?.id, 
      label: b[0]?.area,
      imgUrl:'', 
    };
    setLocationDrop([val]);
  }
  },[localityOption,selectedOption])

  useEffect(() => {
    let sid = siteData[0] && siteData[0]?.id ? siteData[0]?.id?.toString() : "";
    setSites(selectedOption?.site ? selectedOption?.site : sid);
  }, [siteData, selectedOption]);

  useEffect(()=>{
    setCategories(selectedOption.category ? selectedOption.category:'');
    const b = categoryOption.filter((a)=>a?.id?.toString()===selectedOption.category?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.name,
        imgUrl:'', 
      };
      setCatDrop([val]);
    }
    },[categoryOption,selectedOption])
    
    
    useEffect(()=>{
    setSubCategories(selectedOption.subCategory ? selectedOption.subCategory:'');
    const b = subCategoryOption.filter((a)=>a?.id?.toString()===selectedOption.subCategory?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.name,
        imgUrl:'', 
      };
      setSubcatDrop([val]);
    }
    },[subCategoryOption,selectedOption])

    useEffect(()=>{
      setBrands(selectedOption.brand ? selectedOption.brand:'');
      const b = brandOption.filter((a)=>a?.id?.toString()===selectedOption.brand?.toString())
      if (b?.length > 0 && b[0]?.id !== undefined) {
        const val: DropDownOption = {
          value: b[0]?.id, 
          label: b[0]?.name,
          imgUrl: b[0]?.logourl, 
        };
        setBrandDrop([val]);
      }
    },[brandOption,selectedOption])


  useEffect(() => {
    var range = [];
    var num = Math?.ceil(length / limit);
    // let i = 1;

    for (let i = 1; i <= num; i++) {
      range?.push(i);
    }
    setRange(range);
  }, [length, limit]);

  useEffect(() => {
    if (sites !== ""&&selectedOption.isOutletUser===true) {
      let siteCurrencyObject = siteOption?.find(
        (s) => s?.id?.toString() === sites?.toString()
      );
      setValueIn(
        siteCurrencyObject?.currencycode +
          " | " +
          siteCurrencyObject?.valuecaption
      );
    } 
    else if(portfolios !== ""&&selectedOption.isOutletUser===false){
      let portfolioCurrencyObject = portfolioOption?.find(
        (s) => s?.id?.toString() === portfolios?.toString()
      );
      setValueIn(
        portfolioCurrencyObject?.reportingcurrency +
          " | " +
          portfolioCurrencyObject?.valuecaption
      );
    }
    else setValueIn("");
  }, [sites, siteOption,selectedOption]);

  useEffect(() => {
    if (monthlyData?.length > 0)
      setLength(monthlyData[0]?.count ? monthlyData[0]?.count : 0);
  }, [monthlyData]);

  useEffect(() => {
    var getData = {
      portfolio: portfolio,
    };

    if (portfolio?.length > 0 && getData !== undefined) {
      api
        .post<
          APIResponse<{ records: CatSubCatCompanyWithBrandRelationDataType[] }>
        >(`filter/catSubcatCompanyRelationWithBrand`, getData, config)
        .then((response) => {
          if (response?.status === 200 && response?.data?.data) {
            const result = response?.data?.data?.records;
            setCatSubCatCompanyWithBrandRelationData(result);
          }
        })
        .catch((error) => {});
    } else {
      setCatSubCatCompanyWithBrandRelationData([]);
    }
  }, [portfolio]);

   const colors = [
    COLORS?.COLOR1,
    COLORS?.COLOR2,
    COLORS?.COLOR3,
    COLORS?.COLOR4,
    COLORS?.COLOR5,
    COLORS?.COLOR6,
    COLORS?.COLOR7,
    COLORS?.COLOR8,
  ];

  return (
    <UserLayout>
      <div className="card background-transparent p-1">
        <div className="row">
          <div
            className="col-lg-4 wow fadeInLeft ps-0"
          >
            <h4 className="b-title">Footfall Vs Sales</h4>
          </div>

          <div className="col-lg-8 wow fadeInRight">
          <div className="row">
              <div className="col-sm-6 col-md-4 col-lg-3">
                {/* <FormInput2
                  name="Portfolio"
                  label=""
                  labelClassName="required"
                  value={portfolios}
                  onChange={handlePortfolioChange}
                  placeholder="Select"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select</option>
                  {portfolioData?.map((p, i) => {
                    return (
                      <Option value={p?.id} key={i}>
                        {p?.name}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                 {/* <SingleSelect
                  options={[
                    defaultPortfolio,
                    ...portfolioData?.sort(function (a, b) {
                      if (a?.name < b?.name) {
                        return -1;
                      }
                      if (a?.name > b?.name) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.name,
                          imgUrl: s?.logourl,
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={portfoliosOption}
                  setSelectedOptions={handlePortfolioChange}
                  // disabled={disableSite}
                  disabled={disableLocality}
                  placeHolder="Select Portfolio"
                  // filterText=""
                /> */}
                <SingleSelect1
                      options={portfolioData.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.name?c?.name:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={portfolioDrop}
                      setSelectedOptions={handlePortfolioDrop}
                      placeHolder="Select Portfolio"
                      onClear={handleClearPortfolio}
                      disabled = {disableLocality}
                    />
              </div>
              
              <div className="col-sm-6 col-md-4 col-lg-3">
              {/* <FormInput2
                  name="Location"
                  label=""
                  labelClassName="required"
                  value={location}
                  onChange={handleLocationChange}
                  placeholder="Select Locality"
                  containerClass="mb-1"
                  disabled={disableLocality}
                  type="select"
                >
                  <option value="">Select Locality</option>
                  {localityOption?.map((s, i) => {
                    return (
                      <Option value={s?.area} key={i}>
                        {s?.area}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                 {/* <SingleSelect
                  options={[
                    defaultLocation,
                    ...localityOption?.sort(function (a, b) {
                      if (a?.area < b?.area) {
                        return -1;
                      }
                      if (a?.area > b?.area) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.area,
                          imgUrl: '',
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={locationOption}
                  setSelectedOptions={handleLocationChange}
                  disabled={disableLocality}
                  placeHolder="Select Locality"
                  // filterText=""
                /> */}
                   <SingleSelect1
                      options={localityOption.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.area?c?.area:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={locationDrop}
                      setSelectedOptions={handleLocationDrop}
                      placeHolder="Select Locality"
                      onClear={handleClearLocation}
                      disabled = {disableLocality}
                    />
              </div>

            </div>

            <div className="row mt-1">
              <div className="col-sm-6 col-md-4 col-lg-3">
                {/* <FormInput2
                  name="Trade Category"
                  label=""
                  labelClassName="required"
                  value={categories}
                  onChange={handleCategoryChange}
                  placeholder="Select Trade Category"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select Trade Category</option>
                  {categoryOption?.map((s, i) => {
                    return (
                      <Option value={s?.id} key={i}>
                        {s?.name}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                    {/* <SingleSelect
                  options={[
                    defaultTradeCategory,
                    ...categoryOption?.sort(function (a, b) {
                      if (a?.name < b?.name) {
                        return -1;
                      }
                      if (a?.name > b?.name) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.name,
                          imgUrl: '',
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={categoriesOption}
                  setSelectedOptions={handleCategoryChange}
                  // disabled={disableSite}
                  disabled={disableLocality}
                  placeHolder="Select Trade Category"
                  // filterText=""
                /> */}
                <SingleSelect1
                      options={categoryOption.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.name?c?.name:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={catDrop}
                      setSelectedOptions={handleCatDrop}
                      placeHolder="Select Trade Category"
                      onClear={handleClearCat}
                      disabled = {disableLocality}
                    />
              </div>
              <div className="col-sm-6 col-md-4 col-lg-3">
                {/* <FormInput2
                  name="Trade Sub Category"
                  label=""
                  labelClassName="required"
                  value={subCategories}
                  onChange={handleSubCategoryChange}
                  placeholder="Select Trade Subcategory"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select Trade Subcategory</option>
                  {subCategoryFilteredByCategory?.map((s, i) => {
                    return (
                      <Option value={s?.id} key={i}>
                        {s?.name}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                   {/* <SingleSelect
                  options={[
                    defaultTradeSubCategory,
                    ...subCategoryFilteredByCategory?.sort(function (a, b) {
                      if (a?.name < b?.name) {
                        return -1;
                      }
                      if (a?.name > b?.name) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.name,
                          imgUrl: '',
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={subCategoriesOption}
                  setSelectedOptions={handleSubCategoryChange}
                  // disabled={disableSite}
                  disabled={disableLocality}
                  placeHolder="Select Trade Sub Category"
                  // filterText=""
                /> */}
                  <SingleSelect1
                      options={subCategoryFilteredByCategory.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.name?c?.name:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={subcatDrop}
                      setSelectedOptions={handleSubcatDrop}
                      placeHolder="Select Trade Sub Category"
                      onClear={handleClearSubcat}
                      disabled = {disableLocality}
                    />
              </div>
              
              <div className="col-sm-6 col-md-4 col-lg-3">
                {/* <FormInput2
                  name="Brand"
                  label=""
                  labelClassName="required"
                  value={brands}
                  onChange={handleBrandChange}
                  placeholder="Select Brand"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select Brand</option>
                  {BrandFilteredByCompany?.sort(function (a, b) {
                    if (a?.name < b?.name) {
                      return -1;
                    }
                    if (a?.name > b?.name) {
                      return 1;
                    }
                    return 0;
                  })?.map((s, i) => {
                    return (
                      <Option value={s?.id} key={i}>
                        {s?.name}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                {/* <SingleSelect
                  options={[
                    defaultbrand,
                    ...BrandFilteredByCompany?.sort(function (a, b) {
                      if (a?.name < b?.name) {
                        return -1;
                      }
                      if (a?.name > b?.name) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.name,
                          imgUrl: s?.logourl,
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={brandsOption}
                  setSelectedOptions={handleBrandChange}
                  // disabled={disableSite}
                  disabled={disableLocality}
                  placeHolder="Select Brand"
                  // filterText=""
                /> */}
                   <SingleSelect1
                options={BrandFilteredByCompany.map((c, i) => {
        return {
          value: c?.id?c?.id:0,
          label: c?.name?c?.name:'',
          imgUrl: "",
        };
      })}
      selectedOptions={brandDrop}
      setSelectedOptions={handleBrandDrop}
      placeHolder="Select Brand"
                onClear={handleClearBrand}
                disabled = {disableLocality}
              />
              </div>
            </div>
          </div>
        </div>
      </div>

      {loader ? (
        <Loader />
      ) : (
        <>
          <div className="row">
            <div className="col-12">
              <div className="card mt-3 widget_div" onMouseEnter={() => setButtonVisible(true)} onMouseLeave={() => setButtonVisible(false)}>
                {(<button type="button" className="expandIconBtn" onClick={showExpandModalHandler} ><i><FontAwesomeIcon icon={faWindowMaximize} size="lg" title="Open in Popup"/></i></button>)}
                <div className="card-body">
                  <div className="row mb-1">
                    <div className="col-lg-6 col-sm-12">
                      <div className="float-start">
                        <h5 className="header-title mt-1">
                          <img src={chartIcon} alt="icon"></img>Footfall Vs
                          Sales
                        </h5>
                      </div>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                      <div className="float-end hstack gap-1">
                        
                        {selection === SalesPerformanceList?.MONTHLY && (
                          <div
                            className="col-sm-6 col-md-6 col-lg-6"
                            style={{ width: "133px" }}
                          >
                            <div className="DateContainer">
                              <span className="dateInput">
                                <ReactDatePicker
                                  id="DatePicker"
                                  // type="string"
                                  className="text-center fw-bold form-control"
                                  selected={yearAndMonth}
                                  onChange={(date: any) =>
                                    setYearAndMonth(date)
                                  }
                                  showMonthYearPicker
                                  dateFormat="MM/yyyy"
                                  yearItemNumber={8}
                                />
                              </span>
                              <span className="icon">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M14.25 2.6001C14.4709 2.6001 14.65 2.77918 14.65 3.0001V4.26685H16.125C16.7141 4.26685 17.2873 4.47445 17.7165 4.85604C18.1474 5.23898 18.4 5.76918 18.4 6.33351V9.66685V16.3335C18.4 16.8979 18.1474 17.428 17.7165 17.811C17.2873 18.1926 16.7141 18.4002 16.125 18.4002H4.87498C4.28582 18.4002 3.71269 18.1926 3.2834 17.811C2.85259 17.428 2.59998 16.8978 2.59998 16.3335V9.66685V6.33351C2.59998 5.76918 2.85259 5.23898 3.2834 4.85604C3.71269 4.47445 4.28582 4.26685 4.87498 4.26685H6.34998V3.0001C6.34998 2.77918 6.52906 2.6001 6.74998 2.6001C6.97089 2.6001 7.14998 2.77918 7.14998 3.0001V4.26685H13.85V3.0001C13.85 2.77918 14.0291 2.6001 14.25 2.6001ZM17.6 6.33351V9.26685H3.39998V6.33351C3.39998 6.01379 3.54245 5.69614 3.8149 5.45396C4.08888 5.21043 4.46957 5.06685 4.87498 5.06685H6.34998V6.33343C6.34998 6.55434 6.52906 6.73343 6.74998 6.73343C6.97089 6.73343 7.14998 6.55434 7.14998 6.33343V5.06685H13.85V6.33343C13.85 6.55434 14.0291 6.73343 14.25 6.73343C14.4709 6.73343 14.65 6.55434 14.65 6.33343V5.06685H16.125C16.5304 5.06685 16.9111 5.21043 17.1851 5.45396C17.4575 5.69614 17.6 6.01379 17.6 6.33351ZM17.6 10.0668H3.39998V16.3335C3.39998 16.6532 3.54245 16.9709 3.8149 17.2131C4.08888 17.4566 4.46957 17.6002 4.87498 17.6002H16.125C16.5304 17.6002 16.9111 17.4566 17.1851 17.2131C17.4575 16.9709 17.6 16.6532 17.6 16.3335V10.0668ZM10.5 12.6001C10.1595 12.6001 9.82478 12.7199 9.57132 12.9452C9.31632 13.1719 9.16248 13.4901 9.16248 13.8334C9.16248 14.1768 9.31632 14.495 9.57132 14.7217C9.82478 14.947 10.1595 15.0668 10.5 15.0668C10.8405 15.0668 11.1752 14.947 11.4286 14.7217C11.6836 14.495 11.8375 14.1768 11.8375 13.8334C11.8375 13.4901 11.6836 13.1719 11.4286 12.9452C11.1752 12.7199 10.8405 12.6001 10.5 12.6001ZM10.1028 13.5431C10.201 13.4559 10.3432 13.4001 10.5 13.4001C10.6567 13.4001 10.799 13.4559 10.8971 13.5431C10.9938 13.629 11.0375 13.7347 11.0375 13.8334C11.0375 13.9321 10.9938 14.0378 10.8971 14.1237C10.799 14.211 10.6567 14.2668 10.5 14.2668C10.3432 14.2668 10.201 14.211 10.1028 14.1237C10.0062 14.0378 9.96248 13.9321 9.96248 13.8334C9.96248 13.7347 10.0062 13.629 10.1028 13.5431Z"
                                    fill="#6C757D"
                                  ></path>
                                </svg>
                              </span>
                            </div>
                          </div>
                        )}
                        {selection === SalesPerformanceList?.WEEKLY && (
                          <>
                            <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                              <FormInput
                                name="Week"
                                label=""
                                labelClassName="required"
                                value={week}
                                onChange={handleWeek}
                                placeholder="Select Week"
                                containerClass=""
                                type="select"
                              >
                                <option value="">Select Week</option>
                                {weekArray?.map((s, i) => {
                                  return (
                                    <Option value={s} key={i}>
                                      {" "}
                                      {s}
                                    </Option>
                                  );
                                })}
                              </FormInput>
                            </div>
                            <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                              <div className="DateContainer">
                                <span className="dateInput">
                                  <ReactDatePicker
                                    id="DatePicker"
                                    className="text-center fw-bold form-control"
                                    selected={year}
                                    onChange={(date: any) => setYear(date)}
                                    showYearPicker
                                    dateFormat="yyyy"
                                    yearItemNumber={8}
                                  />
                                </span>
                                <span className="icon">
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M14.25 2.6001C14.4709 2.6001 14.65 2.77918 14.65 3.0001V4.26685H16.125C16.7141 4.26685 17.2873 4.47445 17.7165 4.85604C18.1474 5.23898 18.4 5.76918 18.4 6.33351V9.66685V16.3335C18.4 16.8979 18.1474 17.428 17.7165 17.811C17.2873 18.1926 16.7141 18.4002 16.125 18.4002H4.87498C4.28582 18.4002 3.71269 18.1926 3.2834 17.811C2.85259 17.428 2.59998 16.8978 2.59998 16.3335V9.66685V6.33351C2.59998 5.76918 2.85259 5.23898 3.2834 4.85604C3.71269 4.47445 4.28582 4.26685 4.87498 4.26685H6.34998V3.0001C6.34998 2.77918 6.52906 2.6001 6.74998 2.6001C6.97089 2.6001 7.14998 2.77918 7.14998 3.0001V4.26685H13.85V3.0001C13.85 2.77918 14.0291 2.6001 14.25 2.6001ZM17.6 6.33351V9.26685H3.39998V6.33351C3.39998 6.01379 3.54245 5.69614 3.8149 5.45396C4.08888 5.21043 4.46957 5.06685 4.87498 5.06685H6.34998V6.33343C6.34998 6.55434 6.52906 6.73343 6.74998 6.73343C6.97089 6.73343 7.14998 6.55434 7.14998 6.33343V5.06685H13.85V6.33343C13.85 6.55434 14.0291 6.73343 14.25 6.73343C14.4709 6.73343 14.65 6.55434 14.65 6.33343V5.06685H16.125C16.5304 5.06685 16.9111 5.21043 17.1851 5.45396C17.4575 5.69614 17.6 6.01379 17.6 6.33351ZM17.6 10.0668H3.39998V16.3335C3.39998 16.6532 3.54245 16.9709 3.8149 17.2131C4.08888 17.4566 4.46957 17.6002 4.87498 17.6002H16.125C16.5304 17.6002 16.9111 17.4566 17.1851 17.2131C17.4575 16.9709 17.6 16.6532 17.6 16.3335V10.0668ZM10.5 12.6001C10.1595 12.6001 9.82478 12.7199 9.57132 12.9452C9.31632 13.1719 9.16248 13.4901 9.16248 13.8334C9.16248 14.1768 9.31632 14.495 9.57132 14.7217C9.82478 14.947 10.1595 15.0668 10.5 15.0668C10.8405 15.0668 11.1752 14.947 11.4286 14.7217C11.6836 14.495 11.8375 14.1768 11.8375 13.8334C11.8375 13.4901 11.6836 13.1719 11.4286 12.9452C11.1752 12.7199 10.8405 12.6001 10.5 12.6001ZM10.1028 13.5431C10.201 13.4559 10.3432 13.4001 10.5 13.4001C10.6567 13.4001 10.799 13.4559 10.8971 13.5431C10.9938 13.629 11.0375 13.7347 11.0375 13.8334C11.0375 13.9321 10.9938 14.0378 10.8971 14.1237C10.799 14.211 10.6567 14.2668 10.5 14.2668C10.3432 14.2668 10.201 14.211 10.1028 14.1237C10.0062 14.0378 9.96248 13.9321 9.96248 13.8334C9.96248 13.7347 10.0062 13.629 10.1028 13.5431Z"
                                      fill="#6C757D"
                                    ></path>
                                  </svg>
                                </span>
                              </div>
                            </div>
                          </>
                        )}
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleApply}
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="m-0 my-2 p-0 hr" />
                  <div className="col-lg-12 col-sm-12 text-end">
                    <button
                      type="button"
                      onClick={weeklyHandler}
                      className={`m-1 btn btn-xs ${
                        selection === "weekly"
                          ? "btn-sales btn-wek onSelect"
                          : "btn-sales btn-wek text-black"
                      }`}
                    >
                      WEEK
                    </button>
                    <button
                      type="button"
                      onClick={monthlyHandler}
                      className={`m-1 btn btn-xs ${
                        selection === "monthly"
                          ? "btn-sales btn-mom onSelect"
                          : "btn-sales btn-mom text-black"
                      }`}
                    >
                      MOM
                    </button>
                    <button
                      type="button"
                      onClick={yearlyHandler}
                      className={`m-1 btn btn-xs ${
                        selection === "yearly"
                          ? "btn-sales btn-yoy onSelect"
                          : "btn-sales btn-yoy text-black"
                      }`}
                    >
                      YOY
                    </button>
                  </div>
                  {selection === SalesPerformanceList?.YEARLY &&
                    (yearlyData[0]?.record?.length !== undefined &&
                    yearlyData[0]?.record?.length > 0 ? (
                      <FootfallvsSalesYearly 
                      yearlyData={yearlyData} 
                      year={year} 
                      getSubtitle={getSubtitle} 
                      sites={sites}
                      />
                    ) : (
                      <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                        <p className="empty-data">No Records Found</p>
                      </div>
                    ))}
                  {selection === SalesPerformanceList?.MONTHLY &&
                    (monthlyData[0]?.record?.length > 0 &&
                    monthlyData[0]?.record?.length !== undefined ? (
                      <FootfallvsSalesMonthly
                        monthlyData={monthlyData}
                        yearAndMonth={yearAndMonth} 
                        getSubtitle={getSubtitle} 
                        siteData={siteData}
                      />
                    ) : (
                      <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                        <p className="empty-data">No Records Found</p>
                      </div>
                    ))}
                  {selection === SalesPerformanceList?.WEEKLY &&
                    (weeklyData[0]?.record?.length > 0 &&
                    weeklyData[0]?.record?.length !== undefined ? (
                      <FootfallvsSalesWeekly 
                        weeklyData={weeklyData}
                        yearAndMonth={yearAndMonth}
                        week={week}
                        year={year}
                        getSubtitle={getSubtitle}
                        siteData={siteData}
                      />
                    ) : (
                      <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                        <p className="empty-data">No Records Found</p>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card mt-3">
                <div className="card-body">
                  <div className="row mb-1">
                    <div className="col-lg-6 col-sm-12">
                      <div className="float-end hstack gap-1">
                        
                        
                      </div>
                    </div>
                  </div>

                  {selection === SalesPerformanceList?.YEARLY && (
                    <SalesPerformanceTable
                      data={getYearlyTableData()}
                      title={"Yearly Footfall Vs Sales"}
                      fileName={"yearly_footfall_vs_sales"}
                      downloadCSV={true}
                      downloadPDF={true}
                      percent={false}
                    />
                  )}
                  {selection === SalesPerformanceList?.MONTHLY && (
                    <SalesPerformanceTable
                      data={getMonthlyTableData()}
                      title={"Monthly Footfall Vs Sales"}
                      fileName={"monthly_footfall_vs_sales"}
                      downloadCSV={true}
                      downloadPDF={true}
                      percent={false}
                    />
                  )}
                  {selection === SalesPerformanceList?.WEEKLY && (
                    <SalesPerformanceTable
                      data={getWeeklyTableData()}
                      title={"Weekly Footfall Vs Sales"}
                      fileName={"weekly_footfall_vs_sales"}
                      downloadCSV={true}
                      downloadPDF={true}
                      percent={false}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          {showModal && (
        <Modal
        headerText={"Footfall Vs Sales"}
        visible={showModal}
        onClose={() => setShowModal(false)}
        size="xl"
        centered
        classname="widget-container-single" > 
		
    <div className="card-body">
                  {selection === SalesPerformanceList?.YEARLY &&
                    (yearlyData[0]?.record?.length !== undefined &&
                    yearlyData[0]?.record?.length > 0 ? (
                      <FootfallvsSalesYearly 
                      yearlyData={yearlyData} 
                      year={year} 
                      getSubtitle={getSubtitle} 
                      sites={sites}
                      />
                    ) : (
                      <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                        <p className="empty-data">No Records Found</p>
                      </div>
                    ))}
                  {selection === SalesPerformanceList?.MONTHLY &&
                    (monthlyData[0]?.record?.length > 0 &&
                    monthlyData[0]?.record?.length !== undefined ? (
                      <FootfallvsSalesMonthly
                      monthlyData={monthlyData}
                      yearAndMonth={yearAndMonth} 
                      getSubtitle={getSubtitle} 
                      siteData={siteData}
                    />
                    ) : (
                      <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                        <p className="empty-data">No Records Found</p>
                      </div>
                    ))}
                  {selection === SalesPerformanceList?.WEEKLY &&
                    (weeklyData[0]?.record?.length > 0 &&
                    weeklyData[0]?.record?.length !== undefined ? (
                      <FootfallvsSalesWeekly 
                        weeklyData={weeklyData}
                        yearAndMonth={yearAndMonth}
                        week={week}
                        year={year}
                        getSubtitle={getSubtitle}
                        siteData={siteData}
                      />
                    ) : (
                      <div className="d-flex flex-column justify-content-center align-items-center col-12 emptychart-container  ">
                        <p className="empty-data">No Records Found</p>
                      </div>
                    ))}
                </div>
		
		</Modal>)}
        </>
      )}
    </UserLayout>
  );
};
export default FootfallVsSalesReport;
